import React from 'react';
import { CheckIcon } from 'lucide-react';
import { subjects, tramos } from '../data/tramos';
import { TramoCard } from './TramoCard';
import { Accordion } from './Accordion';
type TramosSectionProps = {
  onBuy: (checkoutUrl: string) => void;
};
const tomoIncludes = ['Planificación anual lista para presentar al director/a', 'Actividades listas para el aula', 'Evaluaciones, rúbricas y autoevaluaciones', 'Registro grupal y seguimiento individual'];
export function TramosSection({
  onBuy
}: TramosSectionProps) {
  return <section id="tramos" aria-labelledby="tramos-title" className="bg-cream px-5 pb-12 sm:px-8 lg:pb-16" data-id="element-186" data-mp="3vpv550j3kics">
      <div className="mx-auto w-full max-w-[860px]" data-id="element-187" data-mp="4leli8q5grks">
        <div className="text-center" data-id="element-188" data-mp="9jogai7ypq5v">
          <h2 id="tramos-title" className="font-display text-[26px] font-semibold uppercase leading-tight text-ink sm:text-[30px]" data-id="element-189" data-mp="9in7kkef5frb">
            ¿Solo necesitás tu tramo?
          </h2>
          <p className="mx-auto mt-2 max-w-[46ch] font-sans text-[16px] leading-relaxed text-ink-soft" data-id="element-190" data-mp="2bccnt3rn2zrg">
            Llevá únicamente el nivel con el que trabajás. Cada pack es 100%
            digital y de descarga inmediata.
          </p>
        </div>

        <div className="mt-7 space-y-4" data-id="element-191" data-mp="1xl3ji1waea7d">
          {tramos.map(tramo => <TramoCard key={tramo.id} tramo={tramo} onBuy={() => onBuy(tramo.checkoutUrl)} data-id="element-192" data-mp="1sod5dk41lool" />)}
        </div>

        <div className="mt-4" data-id="element-193" data-mp="1nqbjysj59d9y">
          <Accordion id="tramos-incluye" className="bg-white" openClassName="bg-white" header={<span className="animate-attention font-sans text-[15px] font-bold uppercase tracking-[0.06em] text-coral" data-id="element-195" data-mp="2laemzr50uip7">
                Ver qué incluye cada tramo
              </span>} data-id="element-194" data-mp="2lchcma29i9te">
            <p className="font-display text-[17px] font-bold text-ink" data-id="element-196" data-mp="2bci4ufdo2nhl">
              📚 8 Tomos Completos · Una colección para todo el año
            </p>
            <p className="mt-3 font-sans text-[15px] leading-relaxed text-ink-soft" data-id="element-197" data-mp="zzeloik9ueh6">
              Una propuesta pedagógica integral con 8 tomos, uno por cada área
              del conocimiento, con una estructura práctica y uniforme para
              todos los tramos:
            </p>
            <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-198" data-mp="12djjdybsts7r">
              {subjects.map(subject => <li key={subject} className="rounded-xl bg-cream px-4 py-2.5 font-sans text-[15px] font-medium text-ink" data-id="element-199" data-mp="ngkbsagy5zda">
                  {subject}
                </li>)}
            </ul>
            <p className="mt-5 font-sans text-[15px] font-bold text-ink" data-id="element-200" data-mp="shggurd1brka">
              Cada tomo incluye:
            </p>
            <ul className="mt-3 space-y-2.5" data-id="element-201" data-mp="jep3gm0lmlq0">
              {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-202" data-mp="jgs19s7ztj5a">
                  <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-[#4B7A58]" strokeWidth={2.5} data-id="element-203" data-mp="4rm409spu301" />
                  <span className="font-sans text-[15px] leading-relaxed text-ink-soft" data-id="element-204" data-mp="9n1eqsvffis8">
                    {item}
                  </span>
                </li>)}
            </ul>
            <p className="mt-5 font-sans text-[15px] leading-relaxed text-ink-soft" data-id="element-205" data-mp="3vv2h44fi70t7">
              Todo el material está contextualizado a la realidad uruguaya y
              alineado al Programa EBI · ANEP 2026: una herramienta completa
              para planificar, enseñar, evaluar y acompañar los aprendizajes
              durante todo el año.
            </p>
          </Accordion>
        </div>
      </div>
    </section>;
}